<template>
  <v-data-table-server
    v-model:options="options"
    dense
    :headers="headers"
    :loading="loading"
    :items="items"
    :items-length="totalItems"
    class="elevation-1"
    :items-per-page-options="footerProps.itemsPerPageOptions"
    @update:options="updateTable"
  >
    <template #top>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>LendingTree Customers</v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            @input="searchTable()"
          />

          <v-spacer />

          <v-row
            align="center"
            justify="space-around"
          >
            <v-btn
              color="primary"
              dark
              class="mb-2"
              @click="costReportsOpen = true"
            >
              Daily Cost Reports
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="mb-2"
              @click="productModelOpen = true"
            >
              Product Model
            </v-btn>
          </v-row>

          <LendingtreeCostReportsModal
            v-model="costReportsOpen"
            @close-modal="closeModal('costReportsOpen')"
            @click:outside="closeModal('costReportsOpen')"
          />

          <LendingtreeProductModelModal
            v-model="productModelOpen"
            @close-modal="closeModal('productModelOpen')"
            @click:outside="closeModal('productModelOpen')"
          />
        </v-toolbar>
      </v-card-title>
    </template>

    <template #item.created="{ item }">
      {{ formatDateTime(item.created) }}
    </template>
  </v-data-table-server>
</template>

<script>
import { DateTime } from 'luxon';
import dataTableMixin from '@/mixins/dataTableMixin.js';
import LendingtreeCostReportsModal from '@/views/Leads/Lendingtree/LendingtreeCostReportsModal.vue';
import LendingtreeProductModelModal from '@/views/Leads/Lendingtree/LendingtreeProductModelModal.vue';

export default {
  name: 'LendingtreeLeadIndex',

  components: { LendingtreeProductModelModal, LendingtreeCostReportsModal },

  mixins: [
    dataTableMixin,
  ],

  data: () => ({
    headers: [
      { title: 'ID', value: 'id' },
      { title: 'Lead ID', value: 'lead_id' },
      { title: 'Waterfall', value: 'lead.final_result', sortable: false },
      { title: 'Tracking ID', value: 'lt_tracking_id' },
      { title: 'Filter ID', value: 'lt_filter_id' },
      { title: 'First name', value: 'first_name' },
      { title: 'Last name', value: 'last_name' },
      { title: 'Email', value: 'email' },
      { title: 'Phone', value: 'phone' },
      { title: 'State', value: 'state' },
      { title: 'Status', value: 'status' },
      { title: 'Redirected', value: 'redirected' },
      { title: 'Pre-offer', value: 'offer_sent' },
      { title: 'Date', value: 'created' },
    ],
    costReportsOpen: false,
    productModelOpen: false,
    editedItem: {
      id: null,
    },
  }),

  methods: {
    closeModal(modal) {
      this[modal] = false;
      this.clearState();
    },
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/lendingtree/customers', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        });
    },
    clearState() {
      this.$nextTick(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      });
    },
    formatDateTime(date) {
      return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
  },
};
</script>
